// extracted by css-extract-rspack-plugin
module.exports =  {"root":"FilterControlsToggleButton__root___X8NBc","active":"FilterControlsToggleButton__active___W0TDC","badge":"FilterControlsToggleButton__badge___siAgE"};